import { Execution } from "app/components/analytics/shared/type";

type BuildProps = {
  url?: Execution["buildUrl"];
  number?: Execution["buildNumber"];
};

const BuildNumber = ({ number, url }: BuildProps) => {
  if (number && url) {
    return (
      <a className="color-inherit hover-faded" href={url}>
        Build #{number}
      </a>
    );
  }

  if (url) {
    return (
      <a
        className="color-inherit hover-faded"
        href={url}
        rel="noopener noreferrer"
      >
        Build
      </a>
    );
  }

  if (number) {
    return <>Build #{number}</>;
  }

  return null;
};

export default BuildNumber;
